export class TtfNameTable {
}
